require('dotenv').config();

import React, { useEffect, useState } from 'react';
import { Routes, Navigate, Route, useNavigate } from 'react-router-dom';
import Layout, { Divider, Left, Right, Top } from './appFiles/hoc/Layout/Layout';
const Home = React.lazy(() => import('./appFiles/components/Home/Pages/Home'));
const Legal = React.lazy(() => import('./appFiles/components/Home/Pages/Legal'));
const Appointment = React.lazy(() => import('./appFiles/components/Home/Pages/Appointment'));
const Flowhero = React.lazy(() => import('./appFiles/components/Home/Pages/Flowhero'));

const App = () => {
	
	const [routes, setRoutes] = useState(null);

	const settingRoutes = routes => setRoutes(routes);

	

	useEffect(() => {

		let routes = (
			<Routes>
				<Route path="/home" element={<Home />} />
				<Route path="/flowhero" element={<Flowhero />} />
				<Route path="/legal" element={<Legal />} />
				<Route path="/appointment" element={<Appointment />} />
				<Route path="/version" element={<div>{`Version ${process.env.REACT_APP_VERSION}`}</div>} />
				<Route path="*" element={<Navigate to="/home" />} />
			</Routes>
		);

		settingRoutes(routes);
	}, []);

	return (
		<Layout>
			{routes}
		</Layout>
	);
};

export default App;
